<template>
  <security-menu menu-id="2"></security-menu>
</template>

<script>
import SecurityMenu from "../../../components/security-menu/security-menu.vue";

export default {
  name: "Index",
  components: {SecurityMenu}
}
</script>

<style scoped>

</style>